import { render } from "./familyData.vue?vue&type=template&id=6ec19314"
import script from "./familyData.vue?vue&type=script&lang=js"
export * from "./familyData.vue?vue&type=script&lang=js"

import "./familyData.vue?vue&type=style&index=0&id=6ec19314&lang=css"

import exportComponent from "D:\\proyectos_repositorio_institucional\\ed4\\ed4Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__